<template>
	<div>
		<bsh-datatable 
			:columns="columns"
			:link="$url+'/api/adm/item-materiais/datatable/'+$route.params.id"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            dados: [],
            columns: [
                {
                    label: 'Nome',
                    field: 'nome',
                    order: 'item_materiais.nome',
                    sort: 'asc'
                },
                {
                    label: 'Valor',
                    field: 'valor_br',
                    order: 'item_materiais.valor',
                    sort: 'asc'
                },
                {
                    label: 'Quantidade de produtos',
                    field: 'quantidade_produtos',
                    order: 'item_materiais.quantidade_produtos',
                    sort: 'asc'
                },
                {
                    label: 'Custo por produto',
                    field: 'valor_por_produto_br',
                    order: 'item_materiais.valor_por_produto',
                    sort: 'asc'
                },
            ],
    	}
	},
}
</script>